import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useAllInboxes, VIRTUAL_INBOX_URL_MAP, TEAM_INBOX_ID } from './use-all-inboxes';
import { useLoggedInUser } from 'src/services/api/auth';

export { DEFAULT_INBOX_ID, TEAM_INBOX_ID } from './use-all-inboxes';

const useCurrentInbox = () => {
    const { id: viewId } = useParams<{ id: string }>();
    const { data: allInboxes } = useAllInboxes();
    const { data: loggedInUser } = useLoggedInUser();

    return useMemo(() => {
        if (!viewId) {
            return { inbox: undefined, isDefaultInbox: false, isOwner: false };
        }

        const numericId = viewId in VIRTUAL_INBOX_URL_MAP ? VIRTUAL_INBOX_URL_MAP[viewId] : Number(viewId);
        const inbox = allInboxes?.find(v => v.id === numericId);
        const isDefaultInbox = inbox?.id === TEAM_INBOX_ID;

        return {
            inbox,
            isDefaultInbox,
            isOwner: !inbox?.is_virtual && loggedInUser?.id === inbox?.landlord_user_id,
        };
    }, [viewId, allInboxes, loggedInUser]);
};

export default useCurrentInbox;
